// Default vertex shader - covers the entire canvas
export const defaultVertexShader = `
varying vec2 vUv;

void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;

// Example: Animated gradient
export const gradientShader = `
uniform float u_time;
uniform vec2 u_resolution;
varying vec2 vUv;

void main() {
    vec2 st = vUv;
    
    vec3 color1 = vec3(0.8, 0.3, 0.5);
    vec3 color2 = vec3(0.2, 0.5, 0.8);
    
    float mix_value = sin(u_time * 0.5 + st.x * 3.0) * 0.5 + 0.5;
    vec3 color = mix(color1, color2, mix_value);
    
    gl_FragColor = vec4(color, 1.0);
}
`;

// Example: Ripple effect
export const rippleShader = `
uniform float u_time;
uniform vec2 u_resolution;
varying vec2 vUv;

void main() {
    vec2 st = vUv - 0.5;
    float dist = length(st);
    
    float wave = sin(dist * 20.0 - u_time * 3.0) * 0.5 + 0.5;
    
    vec3 color1 = vec3(0.318, 0.082, 0.129); // #511521
    vec3 color2 = vec3(0.804, 0.816, 0.714); // #CDD0B6
    vec3 color = mix(color1, color2, wave);
    
    gl_FragColor = vec4(color, 1.0);
}
`;

// Example: Noise pattern
export const noiseShader = `
uniform float u_time;
uniform vec2 u_resolution;
varying vec2 vUv;

float random(vec2 st) {
    return fract(sin(dot(st.xy, vec2(12.9898,78.233))) * 43758.5453123);
}

float noise(vec2 st) {
    vec2 i = floor(st);
    vec2 f = fract(st);
    
    float a = random(i);
    float b = random(i + vec2(1.0, 0.0));
    float c = random(i + vec2(0.0, 1.0));
    float d = random(i + vec2(1.0, 1.0));
    
    vec2 u = f * f * (3.0 - 2.0 * f);
    
    return mix(a, b, u.x) + (c - a)* u.y * (1.0 - u.x) + (d - b) * u.x * u.y;
}

void main() {
    vec2 st = vUv * 5.0;
    st += u_time * 0.2;
    
    float n = noise(st);
    
    vec3 color = vec3(n);
    
    gl_FragColor = vec4(color, 1.0);
}
`;

// Example: Wavy pattern
export const wavyShader = `
uniform float u_time;
uniform vec2 u_resolution;
varying vec2 vUv;

void main() {
    vec2 st = vUv;
    
    float wave1 = sin(st.x * 10.0 + u_time) * 0.5;
    float wave2 = sin(st.y * 10.0 + u_time * 0.8) * 0.5;
    
    float pattern = wave1 + wave2;
    
    vec3 color = vec3(pattern + 0.5);
    
    gl_FragColor = vec4(color, 1.0);
}
`;

// Example: Circular gradient with mouse
export const mouseShader = `
uniform float u_time;
uniform vec2 u_resolution;
uniform vec2 u_mouse;
varying vec2 vUv;

void main() {
    vec2 st = vUv;
    vec2 mouse = u_mouse * 0.5 + 0.5; // Normalize to 0-1
    
    float dist = distance(st, mouse);
    float circle = smoothstep(0.5, 0.0, dist);
    
    vec3 color1 = vec3(0.318, 0.082, 0.129);
    vec3 color2 = vec3(0.804, 0.816, 0.714);
    
    vec3 color = mix(color1, color2, circle);
    
    gl_FragColor = vec4(color, 1.0);
}
`;

